<template>
    <div>
        <create-user-form
            ref="createForm"
            @success="userCreated()"
            @cancel="hideModal()"
        ></create-user-form>

        <users-table title="Users" @addUser="showUserModal()" ref="userTable">
            <b-button
                v-show="user_permissions.includes('create.users')"
                variant="primary"
                @click="showUserModal"
                >Add User</b-button
            >
        </users-table>
    </div>
</template>
<script>
import UsersTable from './Users/UsersTable'
import CreateUserForm from './Users/CreateUserForm'

import popupMixins from '@/mixins/popupMixins'

export default {
    name: 'tables',
    components: {
        UsersTable,
        CreateUserForm,
    },
    mixins: [popupMixins],
    data: () => {
        return {}
    },
    computed: {
        user_permissions() {
            return this.$store.getters.user_permissions
        },
    },

    methods: {
        hideModal() {
            this.$refs.createForm.showModal()
        },
        showUserModal() {
            this.$refs.createForm.showModal()
        },
        userCreated() {
            this.doToast('User!', 'User Created', 'success')
            this.$refs.userTable.doSearch()
        },
    },

    mounted() {},
}
</script>
<style></style>
